import { render, staticRenderFns } from "./GenerateTestData.vue?vue&type=template&id=1b9227cc&scoped=true&"
import script from "./GenerateTestData.vue?vue&type=script&lang=js&"
export * from "./GenerateTestData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9227cc",
  null
  
)

export default component.exports